import { BaseWebComponentElement } from '../../../../../../../../framework/BaseWebComponentElement';
import { CveGridController } from '../controller/CveGridController';

export class CveGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CveGridController,
    });
  }

  set patchId(value: string) {
    this.setAttribute('patch-id', value);
  }

  get patchId(): string {
    return this.getAttribute('patch-id') ?? '';
  }
}
